import { ref, reactive, toRefs } from 'vue'
import { PLATFORM_LIST } from '@/common/js/constants.js'
import moment from 'moment'
import { operatorData, ruleKeys } from '../formConstData.js'
import { ptomDetailWarningPlanRuleAdd, ptomDetailWarningPlanRuleUpdate, ptomDetailWarningPlanRuleDelete, ptomDetailWarningPlanRuleByPage } from '@/api/ptom.data.model'

export const useRuleForm = (getTableList) => {
  const ruleFormRef = ref(null)
  const formModel = reactive({
    showRuleFormModal: false,
    addFormConfirmLoading: false,
    queryForm: {
      createOpId: '',
      gameGroupId: ''
    }
  })

  async function onRuleFormConfirm() {
    try {
      await ruleFormRef.value.validate()
      const form = ruleFormRef.value.getFormModel()
      const { ruleId, ...restFormFields } = form

      formModel.addFormConfirmLoading = true
      ; (ruleId ? ptomDetailWarningPlanRuleUpdate({ ...restFormFields, id: ruleId }) : ptomDetailWarningPlanRuleAdd(form)).then(data => {
        if (data) {
          onRuleFormClose()
          getTableList()
        }
      }).finally(() => {
        formModel.addFormConfirmLoading = false
      })
    } catch (e) {
      console.log('ptom plan detail warning error output: ', e)
    }
  }

  function onRuleFormClose() {
    formModel.showRuleFormModal = false
  }

  return {
    ruleFormRef,
    ...toRefs(formModel),
    onRuleFormConfirm,
    onRuleFormClose
  }
}

export const useRuleFormTable = () => {
  const tableModel = reactive({
    tableData: [],
    tableLoading: false,
    pager: {
      pageIndex: 1,
      pageSize: 50,
      total: 0
    }
  })

  const transferRuleToText = (rules) => {
    try {
      rules = JSON.parse(rules)
      const text = rules
        .map((item) => {
          const rule = ruleKeys.find((r) => r.key === item.key)
          const name = rule?.name || ''
          return name ? `${name}${item.operator}${item.value}${rule.unit}` : ''
        })
        .join('、')
      return text
    } catch (e) {
      console.log('transferRuleToText error output: ', e)
    }
  }

  function queryAction(queryForm = {}) {
    tableModel.tableLoading = true
    const { pageIndex, pageSize } = tableModel.pager
    ptomDetailWarningPlanRuleByPage({ ...queryForm, pageIndex, pageSize }).then(data => {
      const { list, page_info } = data || {}
      tableModel.tableData = list.map((item) => {
        return {
          ...item,
          platformText: PLATFORM_LIST.find(p => p.value === item.platform)?.label || '-',
          addTime: moment(item.addTime).format('YYYY-MM-DD HH:mm:ss'),
          ruleText: transferRuleToText(item.ruleCondition)
        }
      }) || []
      tableModel.pager.total = page_info.total_number || 0
    }).finally(() => {
      tableModel.tableLoading = false
    })
  }

  return {
    ...toRefs(tableModel),
    queryAction
  }
}
